import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DirectionsBusFilledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"directions_bus_filled"}/>
}
